export default __webpack_public_path__ + "static/media/model.f7378e2a.jpg";